<template>
  <vxe-grid
    border
    auto-resize
    size="mini"
    :data="data"
    :columns="columns"
    :empty-text="$l('table_label_readBox_fileEmpty') || '暂无处理结果'"
  >
    <template #success="{ row }">
      <el-tag size="mini" :type="row.success ? 'success' : 'danger'">
        {{ row.success ? ($l('table_label_success') || '成功') : ($l('table_label_fail') || '失败') }}
      </el-tag>
    </template>

    <template #message="{ row }">
      <span>{{ row.message || '-' }}</span>
    </template>
  </vxe-grid>
</template>

<script>
export default {
  props: { data: { type: Array, default: () => [] } },
  data() {
    return {
      columns: [
        {
          field: 'fileName',
          title: this.$l('table_label_fileName') || '文件名',
          minWidth: 260,
          showOverflow: true,
        },
        {
          field: 'success',
          title: this.$l('table_label_readBox_processStatus') || '处理状态',
          width: 100,
          align: 'center',
          headerAlign: 'center',
          slots: { default: 'success' },
        },
        {
          field: 'message',
          title: this.$l('table_label_readBox_processMessage') || '处理信息',
          minWidth: 220,
          slots: { default: 'message' },
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped></style>
